import axios from 'axios';
import { auth } from '@/firebase.config';

export async function getClassLive(apiOrigin, classId, signal) {
    if (!auth.currentUser) throw new Error('Sign in to view captions');
    const token = await auth.currentUser.getIdToken();
    if (signal.aborted) throw new Error('Cancelled');
    const response = await axios.get(`${apiOrigin}/api/translation/classes/${encodeURIComponent(classId)}/live`, {
        headers: { Authorization: `Bearer ${token}` }, signal, timeout: 15000,
    });
    return response.data;
}
